export default __webpack_public_path__ + "static/media/google.a45b46e9.svg";